 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import SlackConfigMenu from '../../../../components/SlackConfigMenu'
import SlackProviderLogo from '../../../../components/SlackProviderLogo'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import {MenuPosition} from '../../../../hooks/useCoords'
import useMenu from '../../../../hooks/useMenu'
import useMutationProps, {} from '../../../../hooks/useMutationProps'
import {Providers} from '../../../../types/constEnums'
import SlackClientManager from '../../../../utils/SlackClientManager'

import ProviderRow from './ProviderRow'
import SlackNotificationList from './SlackNotificationList'






const SlackProviderRow = (props) => {
  const {viewer: viewerRef, teamId} = props
  const viewer = useFragment(
    graphql`
      fragment SlackProviderRow_viewer on User {
        ...SlackProviderRowViewer @relay(mask: false)
      }
    `,
    viewerRef
  )
  const atmosphere = useAtmosphere()
  const {submitting, submitMutation, onError, onCompleted} = useMutationProps()
  const mutationProps = {submitting, submitMutation, onError, onCompleted} 
  const {teamMember} = viewer
  const {integrations} = teamMember
  const {slack} = integrations
  const isActive = _optionalChain([slack, 'optionalAccess', _ => _.isActive])
  const openOAuth = () => {
    SlackClientManager.openOAuth(atmosphere, teamId, mutationProps)
  }
  const {togglePortal, originRef, menuPortal, menuProps} = useMenu(MenuPosition.UPPER_RIGHT)

  return (
    React.createElement(React.Fragment, null
      , React.createElement(ProviderRow, {
        connected: !!isActive,
        onConnectClick: openOAuth,
        submitting: submitting,
        togglePortal: togglePortal,
        menuRef: originRef,
        providerName: Providers.SLACK_NAME,
        providerDescription: Providers.SLACK_DESC,
        providerLogo: React.createElement(SlackProviderLogo, null ),}

        , isActive && React.createElement(SlackNotificationList, { teamId: teamId, viewer: viewer,} )
      )
      , menuPortal(
        React.createElement(SlackConfigMenu, { menuProps: menuProps, mutationProps: mutationProps, teamId: teamId,} )
      )
    )
  )
}

graphql`
  fragment SlackProviderRowViewer on User {
    ...SlackNotificationList_viewer
    teamMember(teamId: $teamId) {
      integrations {
        slack {
          isActive
          slackTeamName
          slackUserName
        }
      }
    }
  }
`

export default SlackProviderRow
